import React, { lazy } from "react";
import { Navigate } from "react-router-dom";

const routes = [
  {
    component: () => <Navigate replace to="/dashboard/404" />,
    label: "Not-Found",
    path: "*",
    titleKey: "Not Found",
  },
  {
    component: lazy(() => import("pages/login")),
    label: "Auth Login",
    path: "/",
    titleKey: "login",
  },
  {
    component: lazy(() => import("pages/registration")),
    label: "Register",
    path: "/register",
    titleKey: "Register",
  },
  {
    component: lazy(() => import("pages/business-setup")),
    label: "Business-Setup",
    path: "/setup",
    titleKey: "Business Setup",
  },
  {
    component: lazy(() => import("pages/verification")),
    label: "Verification",
    path: "/verify",
    titleKey: "Verification",
  },
  {
    component: lazy(() => import("pages/forget-password")),
    label: "Forget-Password",
    path: "/forget-password",
    titleKey: "Forget Password",
  },
  {
    children: [
      {
        component: lazy(() => import("pages/not-found")),
        label: "Not-Found",
        path: "404",
      },
      {
        component: lazy(() => import("pages/home-page")),
        label: "dashboard",
        path: "",
      },
      {
        component: lazy(() => import("pages/order-management")),
        label: "order-management",
        path: "order-management",
      },
      {
        component: () => <div>Orders tracking page</div>,
        label: "orders-tracking",
        path: "orders-tracking",
      },
      {
        component: lazy(() => import("pages/orders-creation")),
        label: "manage-orders",
        path: "order-management/manage-orders/:orderType",
      },
      {
        component: lazy(() => import("pages/track-order")),
        label: "manage-orders",
        path: "order-management/track-order/:orderId",
      },
      {
        component: lazy(() => import("pages/my-contacts")),
        label: "My-Contacts",
        path: "my-contacts",
      },
      {
        component: lazy(() => import("pages/address-book")),
        label: "address-book",
        path: "address-book",
      },
      {
        component: lazy(() => import("pages/reports-and-analytics")),
        label: "reports-and-analytics",
        path: "reports-and-analytics",
      },
      {
        component: lazy(() => import("pages/detailed-orders-report")),
        label: "detailed-orders-report",
        path: "detailed-orders-report",
      },
      {
        component: lazy(() => import("pages/actual-data-report")),
        label: "actual-data-report",
        path: "actual-data-report",
      },
      {
        component: lazy(() => import("pages/delivery-performance-report")),
        label: "delivery-performance-report",
        path: "delivery-performance-report",
      },
      {
        component: lazy(() => import("pages/cancellation-and-return-report")),
        label: "cancellation-and-return-report",
        path: "cancellation-and-return-report",
      },
      {
        component: lazy(() => import("pages/time-performance-report")),
        label: "time-performance-report",
        path: "time-performance-report",
      },
      {
        component: lazy(() => import("pages/invoice-and-payment-report")),
        label: "invoice-and-payment-report",
        path: "invoice-and-payment-report",
      },
      {
        component: lazy(() => import("pages/manage-locations")),
        label: "manage-locations",
        path: "manage-locations/:manageType",
      },
      {
        component: lazy(() => import("pages/my-locations")),
        label: "my-locations",
        path: "my-locations",
      },
      {
        component: lazy(() => import("pages/my-profile")),
        label: "my-profile",
        path: "my-profile",
      },
      {
        component: lazy(() => import("pages/settings-page")),
        label: "settings",
        path: "settings",
      },
      {
        component: () => <p>Support page</p>,
        label: "support",
        path: "support",
      },
    ],
    component: lazy(() => import("pages/home-outlet")),
    label: "dashboard",
    path: "/dashboard",
    titleKey: "dashboard",
  },
];

export default routes;
